import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
    return {
        Authorization: `Bearer ${authUser.accessToken}`
    };
};

export const getTemplates = async (filters = {}) => {
    try {
        const response = await axios.get(`${BASE_URL}/api/GmsMessageTemplate`, {
            params: filters,
            headers: getAuthHeader()
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getTemplateById = async (id) => {
    try {
        const response = await axios.get(`${BASE_URL}/api/GmsMessageTemplate/${id}`, {
            headers: getAuthHeader()
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const saveTemplate = async (template) => {
    try {
        if (template.template_id) {
            const response = await axios.put(`${BASE_URL}/api/GmsMessageTemplate/${template.template_id}`, template, {
                headers: getAuthHeader()
            });
            return response.data;
        } else {
            const response = await axios.post(`${BASE_URL}/api/GmsMessageTemplate`, template, {
                headers: getAuthHeader()
            });
            return response.data;
        }
    } catch (error) {
        throw error;
    }
};

export const deleteTemplate = async (id) => {
    try {
        const response = await axios.delete(`${BASE_URL}/api/GmsMessageTemplate/${id}`, {
            headers: getAuthHeader()
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};
